import { Factory, trait, association } from 'miragejs';
import faker from 'faker';

export default {
  // TODO: refactor as common versioned Factory
  email: Factory.extend({
    title: (i) => `${i} ${faker.lorem.sentence()}`,

    // TODO: refactor as common
    currentVersionId: () => faker.random.uuid(),
    publishedVersionId: () => faker.random.uuid(),

    url: () => faker.internet.url(),

    // TODO: refactor as common
    modified: () => faker.date.past().toISOString(),
    modifiedBy: association(),
    created: () => faker.date.past().toISOString(),
    createdBy: association(),

    event: association(),
    sent: trait({
      published: () => faker.date.past().toISOString(),
      publishedBy: association(),
    }),
  }),
};
